// // src/components/manual/ManualViewer.jsx
// // ✅ Manual visible para estudiantes, docentes y administrativos


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import "../style/ModuloManualConvivencia.css";

// const API_BASE =
//   process.env.REACT_APP_API || "http://3.236.217.225:5001/api";

// export default function ManualViewer({ buscar = "" }) {
//   const { token } = useAuth();

//   const [normas, setNormas] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filtro, setFiltro] = useState({
//     gravedad: "todas",
//     q: "",
//   });

//   const api = axios.create({
//     baseURL: API_BASE,
//     headers: token
//       ? { Authorization: `Bearer ${token}` }
//       : {},
//   });

//   /* ===============================
//      📥 MANUAL PÚBLICO
//   =============================== */
//   const fetchNormas = async () => {
//     setLoading(true);
//     try {
//       const { data } = await api.get(
//         "/manual-convivencia/publicas"
//       );

//       setNormas(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Error cargando manual:", error);
//       setNormas([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (token) fetchNormas();
//   }, [token]);

//   /* ===============================
//      🔍 Filtros
//   =============================== */
//   const textoBuscar = (
//     filtro.q || buscar
//   ).toLowerCase().trim();

//   const normasFiltradas = normas
//     .filter((n) =>
//       filtro.gravedad === "todas"
//         ? true
//         : n.gravedad === filtro.gravedad
//     )
//     .filter((n) => {
//       if (!textoBuscar) return true;
//       return `${n.codigo} ${n.descripcion}`
//         .toLowerCase()
//         .includes(textoBuscar);
//     });

//   /* ===============================
//      🖼️ Render
//   =============================== */
//   return (
//     <div className="manual-wrapper">
//       <h2>📘 Manual de Convivencia</h2>

//       <div className="buscador-bar">
//         <input
//           placeholder="Buscar por código o descripción..."
//           value={filtro.q}
//           onChange={(e) =>
//             setFiltro({
//               ...filtro,
//               q: e.target.value,
//             })
//           }
//         />

//         <select
//           value={filtro.gravedad}
//           onChange={(e) =>
//             setFiltro({
//               ...filtro,
//               gravedad: e.target.value,
//             })
//           }
//         >
//           <option value="todas">Todas</option>
//           <option value="leve">Leves</option>
//           <option value="media">Medias</option>
//           <option value="grave">Graves</option>
//         </select>

//         <button className="btn-ghost" onClick={fetchNormas}>
//           🔄 Refrescar
//         </button>
//       </div>

//       {loading ? (
//         <p className="loading">Cargando normas...</p>
//       ) : (
//         <div className="tabla-container">
//           <table className="tabla-manual">
//             <thead>
//               <tr>
//                 <th>Código</th>
//                 <th>Descripción</th>
//                 <th>Gravedad</th>
//               </tr>
//             </thead>
//             <tbody>
//               {normasFiltradas.length === 0 ? (
//                 <tr>
//                   <td colSpan="3">
//                     No se encontraron normas.
//                   </td>
//                 </tr>
//               ) : (
//                 normasFiltradas.map((n) => (
//                   <tr key={n.id}>
//                     <td>{n.codigo}</td>
//                     <td className="descripcion-cell">
//                       {n.descripcion}
//                     </td>
//                     <td
//                       className={`gravedad-${n.gravedad}`}
//                     >
//                       {n.gravedad.toUpperCase()}
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }



///
import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { API  } from "../components/config";
import "../style/ModuloManualConvivencia.css";

const API_URL = `${API}/manual-convivencia`;



export default function ManualViewer({ buscar = "" }) {
  const { token, user } = useAuth();

  const [normas, setNormas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filtro, setFiltro] = useState({
    gravedad: "todas",
    q: "",
  });

  /* ===============================
     AXIOS INSTANCE (SEGURO MULTITENANT)
  =============================== */
  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: API_URL,
      withCredentials: true,
    });

    instance.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;

      config.headers["X-Tenant-ID"] =
        user?.tenant_id || user?.institucion_id || "";

      config.headers["X-Sede-ID"] = user?.sede_id || "";

      return config;
    });

    return instance;
  }, [token, user]);

  /* ===============================
     CARGAR NORMAS
  =============================== */
  const fetchNormas = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/publicas");
      setNormas(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("❌ Error cargando manual:", error);
      setNormas([]);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    if (token) fetchNormas();
  }, [token, fetchNormas]);

  /* ===============================
     FILTRADO SEGURO
  =============================== */
  const normasFiltradas = useMemo(() => {
    const texto = (filtro.q || buscar || "")
      .toString()
      .toLowerCase()
      .trim();

    return normas.filter((n) => {
      const gravedad = n?.gravedad || "";
      const descripcion = n?.descripcion || "";
      const codigo = n?.codigo || "";

      const coincideGravedad =
        filtro.gravedad === "todas" || gravedad === filtro.gravedad;

      const coincideTexto =
        !texto ||
        `${codigo} ${descripcion}`.toLowerCase().includes(texto);

      return coincideGravedad && coincideTexto;
    });
  }, [normas, filtro, buscar]);

  /* ===============================
     UI
  =============================== */
  return (
    <div className="manual-wrapper fade-in">
      <div className="manual-header">
        <h2>📘 Manual de Convivencia</h2>
        <p className="subtitle">
          Normativa institucional y pautas de comportamiento
        </p>
      </div>

      {/* FILTROS */}
      <div className="buscador-bar">
        <input
          type="text"
          placeholder="Buscar por código o descripción..."
          value={filtro.q}
          onChange={(e) =>
            setFiltro((prev) => ({ ...prev, q: e.target.value }))
          }
        />

        <select
          value={filtro.gravedad}
          onChange={(e) =>
            setFiltro((prev) => ({ ...prev, gravedad: e.target.value }))
          }
        >
          <option value="todas">Todas las Gravedades</option>
          <option value="leve">🟢 Leves</option>
          <option value="media">🟡 Medias</option>
          <option value="grave">🔴 Graves</option>
        </select>

        <button onClick={fetchNormas} disabled={loading}>
          {loading ? "..." : "🔄 Refrescar"}
        </button>
      </div>

      {/* CONTENIDO */}
      {loading ? (
        <div className="loading-container">
          <p>Cargando normativa...</p>
        </div>
      ) : (
        <div className="tabla-container">
          <table className="tabla-manual">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
                <th>Gravedad</th>
              </tr>
            </thead>

            <tbody>
              {normasFiltradas.length === 0 ? (
                <tr>
                  <td colSpan="3" className="empty-message">
                    No se encontraron normas.
                  </td>
                </tr>
              ) : (
                normasFiltradas.map((n) => (
                  <tr key={n?.id}>
                    <td>{n?.codigo || "-"}</td>
                    <td>{n?.descripcion || "-"}</td>
                    <td>
                      <span
                        className={`pill-gravedad gravity-${
                          n?.gravedad || "leve"
                        }`}
                      >
                        {(n?.gravedad || "").toUpperCase()}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
